export const RelayApiPath = {
  RECEIVE_HEARTBEAT: '/api/relay-heartbeat', // POST Receive Heartbeat
  GET_RELAY_HEALTH: '/api/relay-health', // GET Get Relay Health
  RECEIVE_RELAY_STATUS: '/api/relay-status', // POST Receive Relay Status
  LIST_RELAY_LOGS: '/api/sites/{site_id}/relay-logs', // GET List Relay Logs
  GET_RELAY_CONFIG: '/api/relay-config' // GET Get Relay Config
}

export type RelayApiPath = (typeof RelayApiPath)[keyof typeof RelayApiPath]

export interface ReceiveHeartbeatVars {
  tenant_id: string
  tenants?: string[]
  failed_count?: number
  retry_count?: number
}

export interface GetRelayHealthVars {}

export interface ReceiveRelayStatusVars {
  tenant_id: string
  filename: string
  status: string
  detail?: string
}

export interface ListRelayLogsVars {
  site_id: number
  page?: number
  per_page?: number
}

export interface GetRelayConfigVars {}

export interface ReceiveHeartbeatResponse {
  ok: boolean
}

export interface GetRelayHealthResponse {
  status: string
  last_seen: string | null
  tenants: string[]
  failed_count: number
  retry_count: number
}

export interface ReceiveRelayStatusResponse {
  ok: boolean
}

export interface RelayLog {
  id: number
  tenant_id: string
  filename: string
  status: string
  detail: string
  created_at: string | null
}

export interface ListRelayLogsResponse {
  total: number
  page: number
  per_page: number
  logs: RelayLog[]
}

export interface RelayTenantConfig {
  api_key: string
  ftp_username: string
  ftp_password: string
}

export interface GetRelayConfigResponse {
  tenants: Record<string, RelayTenantConfig>
}
